import { API, graphqlOperation } from 'aws-amplify';
import { graphQLRequestIAM } from './graphQLService';

const SRSurl = process.env.STUDENT_RECORD_STORE_URL;


const UPDATE_SOR_CONFIG = `
mutation UpdateAmiraLicenses($input: UpdateAmiraLicensesInput!) {
  updateAmiraLicenses(input: $input){
    sorConfig{
      enableERPictures
      enablePracticePictures
      enableGiveWord
      enableFandP
      enableDRA
      enableLexile
      enableExtendedColumns
      selectedStandard
      interventionFrequency
      customARMLevelMapping
    }
    curriculum{
      curriculumId
      displayName
      locale
    }
  }
}`;

const UPDATE_ASSSESSMENT_CONFIG = `
mutation UpdateAssessmentConfig($input: UpdateAmiraLicensesInput!) {
  updateAmiraLicenses(input: $input){
    assessmentEnabled
    screenerEnabled
    letternameConfig
    listeningCompConfig
    readingCompConfig
    vocabularyScreenerConfig
    letterNamingAndSoundsConfig
    spanishConfig
    spellingConfig
    nwfConfig
    iesEnabled
    districtAdminBadgingEnabled
    contentTags
    licensedContent
    windowDisabledByGrade
  }
}`;

const GQL_GET_ASSESSMENT_CONFIG =`
query getLicensing($districtId: Int!, $schoolId: Int!){
  getAmiraLicenses(districtId: $districtId, schoolId: $schoolId) {
    assessmentEnabled
    branding
    screenerEnabled
    letternameConfig
    listeningCompConfig
    readingCompConfig
    vocabularyScreenerConfig
    letterNamingAndSoundsConfig
    spanishConfig
    spellingConfig
    nwfConfig
    contentTags
    licensedContent
    formOverrides {
        assessment
        dyslexia
        listeningComprehension
        nwf
        readingComprehension
        spelling
        vocabularyScreener
    }
    curriculum {
      curriculumId
      displayName
      locale
    }
    windowDisabledByGrade
  }
}`;

const UPDATE_BADGING_CONFIG = `
mutation UpdateBadgingConfig($input: UpdateAmiraLicensesInput!) {
  updateAmiraLicenses(input: $input){
    badgingEnabled
  }
}`;

export async function updateSORConfig(districtId,schools,sorInput, amiraLicenseInputs) {
  let responses = [];
  await Promise.all(schools.map(async (school) => {
    responses.push(await graphQLRequestIAM(SRSurl, UPDATE_SOR_CONFIG, {input: {districtId, schoolId: school.id, sorConfig: sorInput, ...amiraLicenseInputs}}));
  }))
  .catch((e)=>{
    if(e.errors && e.errors[0] && e.errors[0].errorType === "DynamoDB:ConditionalCheckFailedException"){
      console.log("No license table for this school, skipping update");
    }
  });

  return responses;
}

export async function updateBadgingConfig(districtId,schools,badgingConfig) {
  let responses = [];
  await Promise.all(schools.map(async (school) => {
    responses.push(await graphQLRequestIAM(SRSurl, UPDATE_BADGING_CONFIG, {input: {districtId, schoolId: school.id, ...badgingConfig}}));
  }))
  .catch((e)=>{
    if(e.errors && e.errors[0] && e.errors[0].errorType === "DynamoDB:ConditionalCheckFailedException"){
      console.log("No license table for this school, skipping update");
    } else {
      console.error('Update badging config error', e);
    }
  });

  return responses;
}

export async function updateAssessmentConfigForDistrict(districtId,schools,input) {
  let responses = [];
  await Promise.all(schools.map(async ({ id:schoolId }) => {
    responses.push(await updateAssessmentConfigForSchool(districtId, schoolId,input));
  }))
  .catch((e)=>{
    if(e.errors && e.errors[0] && e.errors[0].errorType === "DynamoDB:ConditionalCheckFailedException"){
      console.log("No license table for this school, skipping update");
    }
  });

  return responses;
}

export async function updateAssessmentConfigForSchool(districtId,schoolId,input) {
  let response = null;
  try{
    response = await graphQLRequestIAM(SRSurl, UPDATE_ASSSESSMENT_CONFIG, {input: {districtId, schoolId, ...input}});
  }catch(e){
    if(e.errors && e.errors[0] && e.errors[0].errorType === "DynamoDB:ConditionalCheckFailedException"){
      console.log("No license table for this school, skipping update");
    }else{
      console.log(e)
      throw new Error(e);
    }
  };
  return response;
}

export async function getAssessmentConfig(districtId, schoolId){
  const config = await graphQLRequestIAM(SRSurl, GQL_GET_ASSESSMENT_CONFIG, {districtId,schoolId});
  return config.data && config.data.getAmiraLicenses ? config.data.getAmiraLicenses : null;
}